import defaultHeader from './generated-default-header';
import stepsHeader from './generated-steps-header';
import financeHeader from './generated-finance-header';

import { getAllQueryParams } from '../commons/query';

export function isStepHeader() {
  const { header, h } = getAllQueryParams();
  return header === 'step' || h === 'step' || header === 'basket' || h === 'basket';
}

export function isFinanceHeader() {
  const { header, h } = getAllQueryParams();
  return header === 'finance' || h === 'finance';
}

export function select() {
  if (isStepHeader()) {
    return stepsHeader;
  } else if (isFinanceHeader()) {
    return financeHeader;
  } else {
    return defaultHeader;
  }
}
